import { useNavigate } from "react-router";
import { useSelector, useDispatch } from 'react-redux';

function ManageArea(props: any) {
  let myProps = {
    delete_by_ajax: (inData: any) => { },
    open_write_popup: (inData: any) => { },
    open_manage_inside_sort_popup: (inData: any) => { },
    open_write_multy_popup: (inData: any) => { },
    ...props
  };
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);

  return (
    <div className="my_flex_center">
      <button className="btn btn-sky"
        onClick={() => {
          myProps.open_write_multy_popup({});
        }}>일괄수정</button>
      <button className="btn btn-red"
        onClick={() => {
          myProps.delete_by_ajax();
        }} >삭제</button>

      <button className="btn btn-dark"
        onClick={() => {
          navigate("/comp/plan/word/word_inside/share");
        }}
      >공유</button>

      {user.comp_seq == "4" &&
        <button className="btn btn-dark"
          onClick={() => {
            myProps.open_manage_inside_sort_popup();
          }}
        >카테고리관리</button>
      }
    </div>
  );
};
export default ManageArea;